import React, { useEffect } from "react";
import Gallary from "./photoGallery/Gallary";
import { motion } from "framer-motion";
import Qr from "./qr/Qr";

const Yes = ({ music }) => {
  useEffect(() => {
    const audio = music;
    audio.play().catch((error) => {
      console.error("Audio playback failed:", error);
    });

    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100vw" }}>
      <motion.div
        initial={{ opacity: 1 }}
        animate={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        /* add a delay to the animation */
        transition={{ delay: 3, duration: 2 }}
      >
        <div
          style={{
            textAlign: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "1000",
          }}
        >
          <h1>I Love You!</h1>
          <p>have a scroll through some of our memories</p>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: "100vh" }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        /* add a delay to the animation */
        transition={{ delay: 4, duration: 3 }}
        style={{ zIndex: "-1" }}
      >
        <Gallary />
        <Qr />
      </motion.div>
    </div>
  );
};

export default Yes;
